import { render } from "./signinform.vue?vue&type=template&id=d4f4295e"
import script from "./signinform.vue?vue&type=script&lang=js"
export * from "./signinform.vue?vue&type=script&lang=js"
script.render = render

export default script